import { ChainId } from '@babydogeswap/sdk'

export const NETWORK_URLS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: 'https://bsc-dataseed1.defibit.io',
  [ChainId.TESTNET]: 'https://data-seed-prebsc-1-s1.binance.org:8545',
  [ChainId.ETHEREUM_MAINNET]: 'https://ethereum.publicnode.com',
  [ChainId.POLYGON_TESTNET]: 'https://polygon-mumbai.infura.io/v3/4458cf4d1689497b9a38b1d6bbf05e78',
  [ChainId.POLYGON_MAINNET]: 'https://polygon-rpc.com',
  [ChainId.ARBITRUM_TESTNET]: 'https://goerli-rollup.arbitrum.io/rpc'
}
